import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAnimationState, ISetIsShowAnimationOnEventActionPayload, } from "./animation.t";

const initialState: IAnimationState = {
    shownAnimationsOnEvent: {},
}

export const animationSlice = createSlice({
    name: 'animation',
    initialState,
    reducers: {
        setIsShowAnimationOnEventAction: (state, action: PayloadAction<ISetIsShowAnimationOnEventActionPayload>) => {
            state.shownAnimationsOnEvent[action.payload.eventName] = action.payload.isShow;
        },
    }
});

const websocketReducer = animationSlice.reducer;
export default websocketReducer;
